if (!customElements.get('shop-the-look')) {
  class ShopTheLook extends HTMLElement {
    connectedCallback() {
      this.drawerId = this.dataset.drawerId;

      this.querySelectorAll('.look-thumb[data-look-index]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const idx = parseInt(btn.dataset.lookIndex, 10);
          this.openLook(idx, btn);
        });
      });
    }

    getDrawer() {
      return document.getElementById(this.drawerId);
    }

    openLook(index, triggeredBy) {
      const drawer = this.getDrawer();
      if (!drawer) return;

      const panels = drawer.querySelectorAll('[data-stl-look-panel]');
      if (!panels.length) return;

      this.querySelectorAll('.look-thumb').forEach((b, i) => {
        b.classList.toggle('is-active', i === index);
      });

      panels.forEach((panel) => {
        panel.hidden = parseInt(panel.dataset.stlLookPanel, 10) !== index;
      });

      if (typeof drawer.open === 'function') {
        drawer.open(triggeredBy);
      }
    }
  }

  customElements.define('shop-the-look', ShopTheLook);
}
